import ResourcesDispatcher from "../config/ResourcesDispatcher";
import Utils from "../utils/Utils";
export default class GameAnimations {
    static testMethod() {
        console.log("✅=^.^= GameAnimations library is connected successfully!");
    }
    //Il take event del gioco posso gestirlo tramite get e set
    static resetTakeEvent(getTakeEvent, setTakeEvent) {
        const currentEvent = getTakeEvent();
        if (currentEvent) {
            currentEvent.remove(false);
        }
        setTakeEvent(undefined);
    }
    static playWinningTween(scene, tweenedValues, win, endScale, duration, winAmountText, soundManager, soundToPlay, changeStateMachineCallback, turbo, getTakeEvent, setTakeEvent, onUpdateCallback, onCompleteCallback) {
        return scene.tweens.add({
            targets: tweenedValues,
            value: win,
            scale: endScale,
            duration,
            ease: "Power1",
            onStart: () => {
                this.resetTakeEvent(getTakeEvent, setTakeEvent);
                winAmountText.setVisible(true);
                if (!turbo) {
                    soundManager.playCoinsSound();
                }
                else {
                    soundManager.play(soundToPlay);
                }
                changeStateMachineCallback();
            },
            onUpdate: () => {
                onUpdateCallback(tweenedValues);
            },
            onComplete: () => {
                onCompleteCallback();
            }
        });
    }
    static tweenCounter(scene, text, from, to, loop = false, duration = 1000, onDone, onStartCallback, onUpdateCallback) {
        const tweenTarget = { value: from };
        let tweenConf = {
            targets: tweenTarget,
            value: { from, to },
            duration,
            ease: "Linear",
            repeat: loop ? -1 : 0,
            onStart: () => {
                onStartCallback?.();
            },
            onUpdate: () => {
                text.setText(Utils.formatValue(tweenTarget.value));
                onUpdateCallback?.();
            },
            onComplete: () => {
                text.setText(Utils.formatValue(to));
                onDone?.();
            }
        };
        return scene.tweens.add(tweenConf);
    }
    static async playWinCombinationAnimation(animatedCells, unanimatedCells, lineIndex, moreThanOneLine, startWinningCombinationsTextTween, stopWinningCombinationsTextTween) {
        // Mostra e anima le celle
        animatedCells.forEach((cell) => {
            cell.turnOn();
            cell.showFrame();
        });
        unanimatedCells.forEach((cell) => {
            cell.turnOff();
            cell.showFrame();
        });
        startWinningCombinationsTextTween(!moreThanOneLine);
        if (moreThanOneLine) {
            await Promise.all(animatedCells.map((cell) => cell.playAnimation(false)));
            stopWinningCombinationsTextTween();
            animatedCells.forEach((cell) => {
                cell.turnOff();
                cell.hideFrame();
            });
            unanimatedCells.forEach((cell) => {
                cell.turnOff();
                cell.hideFrame();
            });
        }
        else {
            animatedCells.forEach((cell) => {
                cell.playAnimation(true);
            });
        }
    }
    // funzione che si occupa di ciclare le animazioni di vincita di qualunque combinazione
    static processWinningCellAnimation(reelIndex, cellIndex, animatedCells, unanimatedCells, cell, expanding) {
        if (cellIndex > 0) {
            const wildInfo = window.GameDataManager.getReelSpecialInfo()?.filter((wildInfo) => wildInfo.reelIndex === reelIndex);
            // caso in cui c'è l'extra wild che si espande
            if (wildInfo?.length > 0 && expanding) {
                animatedCells.push(expanding);
            }
            // caso in cui la cella extra wild si moltiplica
            else {
                animatedCells.push(cell);
            }
        }
        else {
            unanimatedCells.push(cell);
        }
    }
    static async animateAllSymbolsWithMemo(reels, memo) {
        const animatedCells = [];
        reels.forEach((reel) => {
            reel.cells.forEach((cell) => {
                if (cell.getMemo() === memo) {
                    animatedCells.push(cell);
                }
            });
        });
        await Promise.all(animatedCells.map((cell) => cell.playAnimation(false)));
    }
    static async animateAllSymbolsWithMemoList(reels, memos) {
        const animatedCells = [];
        reels.forEach((reel) => {
            reel.cells.forEach((cell) => {
                if (memos.includes(cell.getMemo())) {
                    animatedCells.push(cell);
                }
            });
        });
        await Promise.all(animatedCells.map((cell) => cell.playAnimation(false)));
    }
    static async animateWilds(reels, expanding) {
        const wildInfoList = window.GameDataManager.getReelSpecialInfo();
        const winningCombinations = window.GameDataManager.getWinningCombinations();
        if (!wildInfoList.length)
            return;
        const animations = wildInfoList.map((wildInfo) => {
            const { reelIndex, wild } = wildInfo;
            const reelIsWinning = winningCombinations?.length > 0 && winningCombinations.some((combo) => combo.positions[reelIndex] > 0);
            // se è un expanding wild usa la gestione del wild che si espande, altrimenti usa la gestione delle celle animate con extra wild
            return expanding ? this.extraWildExpanding(reels, reelIndex, wild, reelIsWinning) : this.extraWildInCells(reels, reelIndex, wild, reelIsWinning);
        });
        await Promise.all(animations);
    }
    static extraWildExpanding(reels, reelIndex, cellIndex, reelIsWinning) {
        const expandingWild = reels[reelIndex].expandingWild;
        expandingWild.setIndex(cellIndex);
        return expandingWild.expandWild(reelIsWinning);
    }
    static extraWildInCells(reels, reelIndex, cellIndex, reelIsWinning) {
        const cellsWithExtraWild = reels[reelIndex].getCells();
        let promises = [];
        cellsWithExtraWild.forEach((ew, index) => {
            if (index > 0 && index <= ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_CELLS_PER_REEL) {
                ew.setIndex(cellIndex);
                ew.setCellInfo(ResourcesDispatcher.GAME_CONSTANTS.S_EXTRA_WILD);
                promises.push(ew.extraWildAnimation(reelIsWinning));
            }
        });
        return Promise.all(promises);
    }
    static async contractWilds(gameArea) {
        let expandingWilds = [];
        window.GameDataManager.getReelSpecialInfo().forEach((wildInfo) => {
            const expandingWild = gameArea.reels[wildInfo.reelIndex].expandingWild;
            expandingWild.setIndex(wildInfo.wild);
            expandingWilds.push(expandingWild);
        });
        await Promise.all(expandingWilds.map((wild) => wild.contractWild()));
    }
    static playFreeSpinWinningAnimation(reels, numCell) {
        const animatedCells = [];
        reels.forEach((reel) => {
            for (let i = 1; i < numCell; i++) {
                animatedCells.push(reel.freeSpinCells[i]);
            }
        });
        animatedCells.forEach((cell) => cell.playAnimation(true));
    }
    static setWinningLines(combinations) {
        let winningLines = [];
        for (let i = 0; i < combinations.length; i++) {
            winningLines.push({
                symbolPositions: combinations[i].positions,
                index: combinations[i].numOfLine,
                repetitions: combinations[i].repeat,
                symbolIndex: combinations[i].symbol,
                win: combinations[i].win,
                animated: false,
                scatterLine: false
            });
        }
        return winningLines;
    }
    static stopWinCombinationAnimated(animatedCells) {
        animatedCells?.forEach((cell) => {
            cell.stopAnimation();
            cell.hideFrame();
            cell.turnOff();
        });
    }
    static stopWinCombinationUnanimated(unanimatedCells) {
        unanimatedCells?.forEach((cell) => {
            cell.hideFrame();
            cell.turnOff();
        });
    }
}
